var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAboutQuestionMarkLightGray = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7,
    fill: "#071A24",
    fillOpacity: 0.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.96897 10.0257H8.51901V9.90181C8.52832 8.89133 8.8495 8.42898 9.60822 7.95234C10.4647 7.42803 11 6.71306 11 5.62154C11 4.01049 9.7758 3 7.99767 3C6.3685 3 5.04655 3.92469 5 5.73594H6.6571C6.69899 4.83985 7.33204 4.41087 7.98836 4.41087C8.70054 4.41087 9.27308 4.89704 9.27308 5.64538C9.27308 6.31268 8.84019 6.77026 8.27696 7.13251C7.45306 7.65682 6.97828 8.18589 6.96897 9.90181V10.0257ZM7.78355 13C8.33282 13 8.80295 12.5329 8.8076 11.9514C8.80295 11.3794 8.33282 10.9123 7.78355 10.9123C7.21567 10.9123 6.75485 11.3794 6.7595 11.9514C6.75485 12.5329 7.21567 13 7.78355 13Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAboutQuestionMarkLightGray);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/about_question_mark_light_gray.ca31380e3c0290a176a836485fb13d45.svg";